export enum RequestDomainTimeout {
	REPORT = 'REPORT',
	ALERT = 'ALERT',
	USER = 'USER',
	DRIVERS = 'DRIVERS'
}

